import type { AnalyticsEvent, AnalyticsEventPageProperties } from "@octopusdeploy/portal-analytics";
import { useTrackEvent } from "@octopusdeploy/portal-analytics";
import type { PageInstanceSummary } from "@octopusdeploy/portal-routes";
import { usePageInstanceSummary } from "@octopusdeploy/portal-routes";
import { useCallback } from "react";

export function useTrackGlobalSearchActivated() {
    const trackEvent = useTrackEvent();
    const page = usePageInstanceSummary();

    return useCallback(
        (reasonForActivation: ReasonForActivation) => {
            trackEvent(createGlobalSearchActivatedEvent(reasonForActivation, page));
        },
        [page, trackEvent]
    );
}

interface GlobalSearchActivatedEvent extends AnalyticsEvent<"Global search activated">, AnalyticsEventPageProperties {
    "Reason for activation": ReasonForActivation;
}

function createGlobalSearchActivatedEvent(reasonForActivation: ReasonForActivation, page: PageInstanceSummary): GlobalSearchActivatedEvent {
    return {
        eventName: "Global search activated",
        "Page Id": page.Id,
        "Page Area": page.Area,
        "Reason for activation": reasonForActivation,
    };
}

export type ReasonForActivation = "Focused" | "HotKey";
